<template>
  <api-key-form
    v-if="!fetchingApiKey"
    :editing="true"
  />
  <loading-page
    v-else
    full
  />
</template>

<script>
import ApiKeyForm from './ApiKeyForm.vue'

import redirectError from '@/services/redirectError'

export default {
  name: 'ApiKeyEdit',
  components: { ApiKeyForm },
  computed: {
    fetchingApiKey() {
      return this.$store.state.apiKeys.fetchingApiKey
    },
  },
  created() {
    this.fetchApiKey()
  },
  methods: {
    fetchApiKey() {
      if (this.$route.params.id !== undefined) {
        this.$store.dispatch('apiKeys/fetchApiKey', this.$route.params.id).catch(err => redirectError(err, this.$router, this.$route.path))
      }
    },
  },

}
</script>

<style>

</style>
